// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getUserInfo = (username: string) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  const query = `username=${username}`;

  return backendAxios.get(`/users?${query}`);
};

export default getUserInfo;
